module.exports = __webpack_public_path__ + "media/womxnly_cover.dcb3ec63.mp3";